import request from "./http";

class RoleRepository
{
    async getAll() {
        const path = "roles";
        const method = "GET";
        const data = null;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async create(role) {
        const path = "roles/create";
        const method = "POST";
        const data = role;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async edit(role) {
        const path = "roles/edit";
        const method = "POST";
        const data = role;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async gridview(query) {
        const path = "roles/gridview";
        const method = "POST";
        const data = query;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async getOneById(id) {
        const path = "roles/get";
        const method = "GET";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }
}

export default RoleRepository;